import api, { unwrap } from './client';

/* Détail des charges indirectes (hors personnel), tenant × année.

   Le détail est la SAISIE, le montant annuel de la base costing en est le
   RÉSULTAT : le serveur le recompose à chaque écriture, l'écran n'a donc
   jamais à le tenir à jour lui-même. */

export const listIndirectItems = (tenantId, year) =>
  unwrap(api.get(`/tdabc/indirect-items/${tenantId}`, { params: { year } }));

export const createIndirectItem = (tenantId, year, payload) =>
  unwrap(api.post(`/tdabc/indirect-items/${tenantId}`, payload, { params: { year } }));

export const updateIndirectItem = (tenantId, itemId, payload) =>
  unwrap(api.patch(`/tdabc/indirect-items/${tenantId}/${itemId}`, payload));

export const deleteIndirectItem = (tenantId, itemId) =>
  unwrap(api.delete(`/tdabc/indirect-items/${tenantId}/${itemId}`));

/* Part d'un groupe sur une ligne. Le serveur recompose le total annuel ET les
   charges spécifiques par groupe : l'écran n'a rien à tenir à jour. */
export const setIndirectAllocation = (tenantId, itemId, costPoolId, amount) =>
  unwrap(api.put(`/tdabc/indirect-items/${tenantId}/${itemId}/allocation`,
    { cost_pool_id: costPoolId, amount }));
